import { useVisitedViewStore } from '@/stores';

export const visitWinHook = (to) => {
    const viewStore = useVisitedViewStore();
    const route = to;
    const generateRoute = () => {
        const { meta } = route;
        const { title, tabWin = false } = meta || {};
        if (tabWin && !!title) {
            return route;
        }
        return false;
    };

    const addViewTag = () => {
        const route = generateRoute();
        if (!route) {
            return false;
        }
        const {
            path = '',
            meta: { title = '', group = '', closable = true } = {},
            name = '',
            params = {},
            query = {},
        } = route || {};
        viewStore.addView({
            name: name || '',
            path,
            params,
            query,
            meta: {
                title: title || '',
                group: group || '',
                closable: closable,
            },
        });
    };
    addViewTag();
};
